import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import questionMsg from "./modules/questionMsg";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    questionMsg,
  },
});
